var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMembersDefaultWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.667 4)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.783 0c2.208 0 3.997 1.755 3.997 3.92 0 2.164-1.79 3.92-3.997 3.92a4.057 4.057 0 0 1-1.456-.269c1.49-.57 2.543-1.99 2.543-3.651 0-1.661-1.054-3.081-2.541-3.652.45-.173.94-.268 1.454-.268z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.417,
    cy: 3.92,
    rx: 3.997,
    ry: 3.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 8.96c2.53 0 4.575 2.006 4.575 4.498v2.787a.562.562 0 0 1-.566.555h-2.91c.311 0 .565-.25.565-.555v-2.787c0-2.492-2.045-4.497-4.575-4.497z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.26 8.96H4.586C2.057 8.96 0 10.978 0 13.459v2.787c0 .306.254.555.566.555h13.702c.312 0 .566-.25.566-.555v-2.787c0-2.492-2.045-4.497-4.575-4.497z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMembersDefaultWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-members-default-white.28a22d59f929a4687949beef4290901d.svg";